// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"159":"27e4b3d0","453":"acca0757","538":"012a2ac9"}[chunkId] + ".chunk.js";
};